var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/List/List"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49999 5.00001C2.96023 5.00001 3.33332 4.62691 3.33332 4.16668C3.33332 3.70644 2.96023 3.33334 2.49999 3.33334C2.03975 3.33334 1.66666 3.70644 1.66666 4.16668C1.66666 4.62691 2.03975 5.00001 2.49999 5.00001Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49999 10.8333C2.96023 10.8333 3.33332 10.4602 3.33332 10C3.33332 9.53977 2.96023 9.16668 2.49999 9.16668C2.03975 9.16668 1.66666 9.53977 1.66666 10C1.66666 10.4602 2.03975 10.8333 2.49999 10.8333Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 15.8333C3.33332 16.2936 2.96023 16.6667 2.49999 16.6667C2.03975 16.6667 1.66666 16.2936 1.66666 15.8333C1.66666 15.3731 2.03975 15 2.49999 15C2.96023 15 3.33332 15.3731 3.33332 15.8333Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49999 9.49993C5.22385 9.49993 4.99999 9.72379 4.99999 9.99993C4.99999 10.2761 5.22385 10.4999 5.49999 10.4999H17.8333C18.1095 10.4999 18.3333 10.2761 18.3333 9.99993C18.3333 9.72379 18.1095 9.49993 17.8333 9.49993H5.49999Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 4.1666C4.99999 3.89045 5.22385 3.6666 5.49999 3.6666H17.8333C18.1095 3.6666 18.3333 3.89045 18.3333 4.1666C18.3333 4.44274 18.1095 4.6666 17.8333 4.6666H5.49999C5.22385 4.6666 4.99999 4.44274 4.99999 4.1666Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49999 15.3333C5.22385 15.3333 4.99999 15.5571 4.99999 15.8333C4.99999 16.1094 5.22385 16.3333 5.49999 16.3333H17.8333C18.1095 16.3333 18.3333 16.1094 18.3333 15.8333C18.3333 15.5571 18.1095 15.3333 17.8333 15.3333H5.49999Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.5ee16fade0e813072ca1a6dd55ed724a.svg";
export { ForwardRef as ReactComponent };